import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "row-line" }, null, -1)
const _hoisted_2 = { class: "d-flex align-items-center row-content p-field-radiobutton" }
const _hoisted_3 = {
  key: 0,
  class: "mt-1 text-gray"
}
const _hoisted_4 = {
  key: 0,
  class: "row-line"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")

  return (_openBlock(), _createBlock("div", {
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setRadioValue())),
    class: ["list-item-radio", { 'listitem-disabled': _ctx.disabled }]
  }, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_RadioButton, {
        inputId: _ctx.inputId,
        name: _ctx.name,
        value: _ctx.value,
        modelValue: _ctx.localValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.localValue = $event)),
        disabled: _ctx.disabled
      }, null, 8, ["inputId", "name", "value", "modelValue", "disabled"]),
      _createVNode("label", {
        class: "ml-2",
        for: _ctx.inputId
      }, [
        _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
        (_ctx.sublabel)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode("small", null, _toDisplayString(_ctx.sublabel), 1)
            ]))
          : _createCommentVNode("", true)
      ], 8, ["for"]),
      _renderSlot(_ctx.$slots, "info-label")
    ]),
    (_ctx.last)
      ? (_openBlock(), _createBlock("div", _hoisted_4))
      : _createCommentVNode("", true)
  ], 2))
}